import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import Heading from "../../components/Heading";

import whatwedo from "../../images/whatwedo.png";

import whatwedo2 from "../../images/whatwedo2.png";

const Img = styled.div`
  width: 95%;
  @media (max-width: 599px) {
    width: 100%;
  }
`;

const Img1 = styled.img`
  margin-top: 35px;
  width: 100%;
  height: 364px;
  @media (max-width: 499px) {
    height: 350px;
  }
  @media (max-width: 399px) {
    height: 300px;
  }
`;

const Text = styled.div`
  font-size: 20px;
  max-width: 80%;
  @media (max-width: 599px) {
    font-size: 15px;
    max-width: 95%;
  }
`;
const Cells = styled.div`
  @media (max-width: 899px) {
    padding-left: 20px;
  }
`;
const Wrapper = styled.div`
  padding-top: 130px;
  padding-bottom: 130px;
  @media (max-width: 599px) {
    padding-bottom: 100px;
  }
`;
const Head = styled.h3`
  @media (max-width: 599px) {
    margin-left: -10px;
  }
`;

const index = () => {
  return (
    <div>
      <Container maxWidth="xl">
        <Wrapper id="about">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Img>
                <img className="img-fluid" src={whatwedo} />
              </Img>
            </Grid>
            <Grid item xs={12} md={6}>
              <Cells>
                <Head>
                  <Heading mt="30px">What we do</Heading>
                </Head>
                <Text>
                  The time has come to fulfill your dreams of a beautiful, safe
                  and affordable expansion in your home. With Paramount Vault,
                  make your home energy-efficient with the help of solar panels
                  and recharge bore!
                  <br />
                  <br /> Provide ease in the life of elderly people by
                  installing cost-effective and reliable elevators Elevators
                  <br />
                  <br /> Expand your home in style! With the help of
                  pre-fabtricated structures, you can upgrade the look of your
                  home more frequently, easily, and reliably!
                </Text>
                <Img>
                  <Img1 className="img-fluid" src={whatwedo2} />
                </Img>
              </Cells>
            </Grid>
          </Grid>
        </Wrapper>
      </Container>
    </div>
  );
};

export default index;
